import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import {
  FormDefinition,
  FormPending,
  FormSubmission,
  GetFormSubmissionResponse,
  GetFormResponse,
  PendingFormsResponse,
  SaveFormSubmissionResponse,
} from '../models';

const pendingFormsUrl = (idApplicantTraining: number): string =>
  `${environment.apiurl}/api/v3.0/applicant-forms/${idApplicantTraining}/forms/pending`;

const formDefinitionUrl = (formName: string): string =>
  `${environment.apiurl}/api/v3.0/forms/${formName}`;

const submissionUrl = (formName: string, idApplicantTraining: number): string =>
  `${environment.apiurl}/api/v3.0/forms/${formName}/submissions?idApplicantTraining=${idApplicantTraining}`;

@Injectable({ providedIn: 'root' })
export class DynamicFormService {
  constructor(private http: HttpClient) {}

  getPendingForms(idApplicantTraining: number): Observable<FormPending[]> {
    return this.http
      .get<PendingFormsResponse>(pendingFormsUrl(idApplicantTraining))
      .pipe(map((response) => response.pendingForms));
  }

  getFormDefinition(formName: string): Observable<FormDefinition> {
    return this.http
      .get<GetFormResponse>(formDefinitionUrl(formName))
      .pipe(map((response) => response.form));
  }

  getSubmission(
    formName: string,
    idApplicantTraining: number
  ): Observable<GetFormSubmissionResponse | null> {
    return this.http
      .get<GetFormSubmissionResponse>(submissionUrl(formName, idApplicantTraining))
      .pipe(
        catchError((error: HttpErrorResponse) =>
          error.status === 404 ? of(null) : throwError(() => error)
        )
      );
  }

  saveAnswers(
    formName: string,
    submission: FormSubmission
  ): Observable<SaveFormSubmissionResponse> {
    return this.http.post<SaveFormSubmissionResponse>(
      submissionUrl(formName, submission.idApplicantTraining),
      { submission }
    );
  }
}
